import React, { useState } from "react";
import "./venture.css";

const VentureLogin = ({ history }) => {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const handleContinue = async (e) => {
    e.preventDefault();
  
    if (!email.trim()) {
      setError("Please enter your email.");
      return;
    }
  
    setLoading(true);
    setError("");
  
    try {
      const response = await fetch(
        "https://api-discloseai.essolutions.ai/api/v1/workspace/check-user-access-wrkspc",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            email,
          }),
        }
      );
  
      const data = await response.json();
  
      console.log("Workspace Response:", data);
  
      // User is valid if email and role are returned
      if (response.ok && data.email && data.role) {
        localStorage.setItem("venture_email", data.email);
        localStorage.setItem("venture_role", data.role);
        localStorage.setItem("venture_is_authenticated", "true");
  
        history.push("/venture");
      } else {
        setError(data.message || "You don't have access to this workspace.");
      }
    } catch (err) {
      console.error(err);
      setError("Something went wrong. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="venture-login-page">

      <form
        className="venture-login-card"
        onSubmit={handleContinue}
      >

        <h2>Workspace Access</h2>

        <p>
          Enter your email to continue.
        </p>

        <input
          type="email"
          placeholder="Email Address"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />

        {error && (
          <div className="venture-error">
            {error}
          </div>
        )}

        <button disabled={loading}>
          {loading ? "Checking..." : "Continue"}
        </button>

      </form>

    </div>
  );
};

export default VentureLogin;